import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import UrgenceBanner from "@/components/UrgenceBanner";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Material3D from "@/components/Material3D";
import Gallery from "@/components/Gallery";
import BeforeAfter from "@/components/BeforeAfter";
import Manifesto from "@/components/Manifesto";
import DevisForm from "@/components/DevisForm";
import Zones from "@/components/Zones";
import Trust from "@/components/Trust";
import Faq from "@/components/Faq";
import BlogTeaser from "@/components/BlogTeaser";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import CityPage from "@/pages/CityPage";
import ServicePage from "@/pages/ServicePage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import NotFound from "@/pages/NotFound";
import Preloader from "@/components/Preloader";
import FloatingCall from "@/components/FloatingCall";

function HomePage() {
  useEffect(() => {
    if (window.location.hash) {
      const hash = window.location.hash;
      const t = setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 700);
      return () => clearTimeout(t);
    }
  }, []);
  return (
    <div className="min-h-screen bg-[#0D0F12] text-slate-200 antialiased">
      <Preloader />
      <Navbar />
      <main>
        <Hero />
        <UrgenceBanner />
        <Services />
        <Material3D />
        <Marquee />
        <Gallery />
        <BeforeAfter />
        <Manifesto />
        <DevisForm />
        <Zones />
        <Trust />
        <Faq />
        <BlogTeaser />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/couvreur/:slug" element={<CityPage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/conseils" element={<Blog />} />
        <Route path="/conseils/:slug" element={<BlogPost />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/mentions-legales" element={<Legal />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster theme="dark" position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
